







































































import { Component, Vue } from 'vue-property-decorator';
import { SysKBContentDetailsModule } from '@/store/modules/sysKBContentDetails';
import CreateKBContentRequest from '@/models/KnowledgeBase/CreateKBContentRequest';
import ListUtils from '@/lib/listUtils';
import KBVisibility from '@/models/KnowledgeBase/KBVisibility';

@Component({
  name: 'CreateKBContent'
})
export default class CreateKBContent extends Vue {
  private valid = false;
  private creating = false;
  private title = '';
  private slug = '';
  private visibility: number = KBVisibility.Internal;

  private autoGenerateSlug = true;

  private rules = {
    required: (value: string) => !!value || 'This field is required',
    slug: (value: string) => {
      const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
      return slugPattern.test(value) || 'Slug must be lowercase letters, numbers, and hyphens only';
    }
  };

  get visibilityOptions() {
    return ListUtils.contentVisibilityOptions();
  }

  updateSlug() {
    if (this.autoGenerateSlug && this.title) {
      this.slug = this.generateSlug(this.title);
    }
  }

  generateSlug(text: string): string {
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, '') // Remove special chars
      .replace(/\s+/g, '-')     // Replace spaces with hyphens
      .replace(/-+/g, '-')      // Collapse multiple hyphens
      .replace(/^-+|-+$/g, ''); // Trim hyphens from ends
  }

  async create() {
    if (!this.valid) return;

    this.creating = true;
    try {
      const request = new CreateKBContentRequest();
      request.title = this.title;
      request.slug = this.slug;
      request.visibility = this.visibility;

      const result = await SysKBContentDetailsModule.createContent(request);

      this.$emit('created', result.id);
      this.reset();
    } finally {
      this.creating = false;
    }
  }

  reset() {
    this.title = '';
    this.slug = '';
    this.visibility = KBVisibility.Internal;
    this.autoGenerateSlug = true;
    (this.$refs.form as any).resetValidation();
  }
}
